import * as React from 'react';
import { cn } from '../lib/utils';

type TimePickerProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type' | 'value' | 'onChange'
> & {
  value: Date | null;
  onChange: (date: Date | null) => void;
  label?: string;
};

function toTimeString(date: Date): string {
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  return `${h}:${m}`;
}

const TimePicker = React.forwardRef<HTMLInputElement, TimePickerProps>(
  ({ value, onChange, label, className, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      if (!val) {
        onChange(null);
        return;
      }
      const [h, m] = val.split(':').map(Number);
      const next = value ? new Date(value) : new Date();
      next.setHours(h, m, 0, 0);
      onChange(next);
    };

    return (
      <input
        ref={ref}
        type="time"
        value={value ? toTimeString(value) : ''}
        onChange={handleChange}
        aria-label={label}
        className={cn(
          'h-control-md w-full rounded-md border border-input bg-background px-control-x-sm type-body-sm text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/25 disabled:cursor-not-allowed disabled:opacity-disabled',
          className,
        )}
        {...props}
      />
    );
  },
);

TimePicker.displayName = 'TimePicker';

export { TimePicker };
export type { TimePickerProps };
